import smoothscroll from 'smoothscroll-polyfill';
// import { CFG } from './config';
import {
    Dropdown,
    ModalMenu,
    ModalNewGraduates,
    Accordion,
    AnchorScroll,
    ScrollManager,
    ImageSlides,
} from './_main';

// home
import {
    // VisualSlides,
    AutoMovingSlides,
    ScrollSlides,
    OfficeTourSlides,
    ScrollEndlessAnimation,
    ScrollTitleAnimation,
    EntriesScrollTrigger,
    OpeningAnimation,
} from './_home'

// work-field
import {
    WorkFieldVisualSlides,
    WorkFieldAreaSlides,
} from './_work-field'

// interview
import {
    ScheduleScrollTrigger,
    PrivateSlides,
    RelatedInterviewSlides,
    FilteringInterview,
} from './_interview'

// crosstalk
import {
    ScrollMemberSlides,
} from './_crosstalk'

// main
{
    smoothscroll.polyfill();

    const domModalMenu = document.querySelector('[data-js="trigger"]');
    if (domModalMenu) new ModalMenu(domModalMenu);

    const domModalNewGraduates = document.querySelectorAll('[data-js="newgraduates"]');
    if (domModalNewGraduates) new ModalNewGraduates(domModalNewGraduates);

    const domAnchorScroll = [...document.querySelectorAll('a[href^="#"]')];
    if ( domAnchorScroll ) {
        domAnchorScroll.forEach(el => {
            new AnchorScroll(el);
        });
    }

    const domDropdown = document.querySelectorAll('[data-js="dropdown"]');
    if (domDropdown) {
        [...domDropdown].forEach(el=>{
            new Dropdown(el);
        })
    }

    const domAccordion = document.querySelectorAll('[data-js="accordion"]');
    if (domAccordion) {
        [...domAccordion].forEach(el=>{
            new Accordion(el);
        });
    }

    const domScroller = document.querySelector('[data-scroller]');
    if (domScroller) new ScrollManager(domScroller);
}

// home
{
    const domOpeningAnimation = document.querySelector('[data-js="opening"]');
    if (domOpeningAnimation) new OpeningAnimation(domOpeningAnimation);

    const domScrollEndlessAnimation = document.querySelector('[data-js="endless"]');
    if (domScrollEndlessAnimation) new ScrollEndlessAnimation(domScrollEndlessAnimation);

    const domScrollTitleAnimation = document.querySelectorAll('[data-js="scroll-title"]');
    if (domScrollTitleAnimation) {
        [...domScrollTitleAnimation].forEach(el=>{
            new ScrollTitleAnimation(el);
        })
    }

    // const domVisualSlides = document.querySelector('[data-js="visual"]');
    // if (domVisualSlides) new VisualSlides(domVisualSlides);
    
    const domAutoMovingSlides = document.querySelector('[data-js="images-slide"]');
    if (domAutoMovingSlides) new AutoMovingSlides(domAutoMovingSlides);
    
    const domInterviewSlides = document.querySelector('[data-js="interview-slide"]');
    if (domInterviewSlides) new ScrollSlides(domInterviewSlides);

    const domOfficeTourSlides = document.querySelector('[data-js="office-tour"]');
    if (domOfficeTourSlides) new OfficeTourSlides(domOfficeTourSlides);

    const domEntriesScrollTriggerDetect = document.querySelector('[data-stc="detect"]');
    const domEntriesScrollTriggerTarget = document.querySelector('[data-stc="target"]');
    if (domEntriesScrollTriggerTarget) new EntriesScrollTrigger(domEntriesScrollTriggerDetect, domEntriesScrollTriggerTarget);  
}

// work-field
{
    const domWorkFieldVisualSlides = document.querySelector('[data-js="work-field-visual"]');
    if (domWorkFieldVisualSlides) new WorkFieldVisualSlides(domWorkFieldVisualSlides);

    const domWorkFieldAreaSlides = document.querySelector('[data-js="work-field-area"]');
    if (domWorkFieldAreaSlides) new WorkFieldAreaSlides(domWorkFieldAreaSlides);
}

// interview
{
    const domScheduleScrollTrigger = document.querySelectorAll('[data-js="schedule-trigger"]');
    if (domScheduleScrollTrigger) {
        [...domScheduleScrollTrigger].forEach(el => {
            new ScheduleScrollTrigger(el);
        })
    }

    const domPrivateSlides = document.querySelector('[data-js="private"]');
    if (domPrivateSlides) new PrivateSlides(domPrivateSlides);

    const domRelatedInterviewSlides = document.querySelector('[data-js="related-slides"]');
    if (domRelatedInterviewSlides) new RelatedInterviewSlides(domRelatedInterviewSlides);

    const domFilteringInterview = document.querySelector('[data-js="filtering"]');
    if (domFilteringInterview) new FilteringInterview(domFilteringInterview);
}

// crosstalk
{
    const domScrollMemberSlides = document.querySelector('[data-js="member-slide"]');
    if (domScrollMemberSlides) new ScrollMemberSlides(domScrollMemberSlides);
}

// graduate / career
{
    const domImageSlides = document.querySelectorAll('[data-js="image-slides"]');
    if (domImageSlides) {
        [...domImageSlides].forEach(el=>{
            new ImageSlides(el);
        })
    }
}
